import type { MultiValueProps } from '@common/ui-components';
import { MultiValue as SelectMultiValue } from '@common/ui-components';

export default function MultiValue(props: MultiValueProps) {
  return <SelectMultiValue {...props}>{props.data.label}</SelectMultiValue>;
}
